import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type UpdateSaltoSpaceUserRequest = {
  email: string
  doorIds: string[]
  permissionGroupIds: string[]
  accessLevelIds: string[]
  authorizationCodes?: string[]
  expirationDate?: number
}

const updateSaltoSpaceUser = async (data: UpdateSaltoSpaceUserRequest) => {
  const response = await authAPI.patch('/salto-space/user', data)
  return response.data
}

export const useUpdateSaltoSpaceUser = () =>
  useMutation({
    mutationFn: updateSaltoSpaceUser,
  })
